// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTARecord } from './dta-record';
import {
    DTARecordFromJSON,
    DTARecordFromJSONTyped,
    DTARecordToJSON,
    DTARecordToJSONTyped,
} from './dta-record';

/**
 * 
 * @export
 * @interface StudyDtaListResponse
 */
export interface StudyDtaListResponse {
    /**
     * 
     * @type {number}
     * @memberof StudyDtaListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<DTARecord>}
     * @memberof StudyDtaListResponse
     */
    items: Array<DTARecord>;
    /**
     * 
     * @type {string}
     * @memberof StudyDtaListResponse
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the StudyDtaListResponse interface.
 */
export function instanceOfStudyDtaListResponse(value: object): value is StudyDtaListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function StudyDtaListResponseFromJSON(json: any): StudyDtaListResponse {
    return StudyDtaListResponseFromJSONTyped(json, false);
}

export function StudyDtaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyDtaListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'items': ((json['items'] as Array<any>).map(DTARecordFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function StudyDtaListResponseToJSON(json: any): StudyDtaListResponse {
    return StudyDtaListResponseToJSONTyped(json, false);
}

export function StudyDtaListResponseToJSONTyped(value?: StudyDtaListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'items': ((value['items'] as Array<any>).map(DTARecordToJSON)),
        'nextToken': value['nextToken'],
    };
}
